// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"732":"0d5ad4de","977":"c8a1c819"}[chunkId] + ".chunk.js");